module.exports = __webpack_public_path__ + "img/main.11b83392.png";